var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-card"},[_c('div',{staticClass:"header"},[_c('h4',[_vm._v("TOTAL VENDIDO y RENTABILIDAD de cada proveedor")]),_c('chart-options',{attrs:{"store_name":"total_vendido_y_rentabilidad","total_registros_text":_vm.total_registros_text,"registros_para_mostrar":_vm.providers_formated}})],1),_c('total-vendido-y-rentabilidad')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }